import React from "react";
import { useTranslation } from "react-i18next";
import { getFormattedItemCost } from "go-core/utils/utils";
import { OrderItemData } from "../../../../../../../../../services/Api/Public/types";

interface Props {
	item: OrderItemData;
}

const ItemListItem = ({ item }: Props) => {
	const { t } = useTranslation();

	const getName = (item: OrderItemData) => {
		let name = item.product?.name ?? t("modules.e_order.field.no_name_product.title");

		if (item.quantity > 1) {
			name += ` x${item.quantity}`;
		}

		return name;
	};

	const renderFirstLevel = () => {
		return (
			<div>
				<span>{getName(item)}</span>
				<div className="d-flex align-items-center gap-1">
					{item.sub_total_price.amount !== item.total_price.amount && (
						<small className="text-decoration-line-through">
							{getFormattedItemCost(item.sub_total_price.amount, item.sub_total_price.currency)}
						</small>
					)}
					<span>{getFormattedItemCost(item.total_price.amount, item.total_price.currency)}</span>
				</div>
			</div>
		);
	};

	const renderSecondLevel = () => {
		if (item.removed_items.length === 0 && item.included_items.length === 0) return null;

		return (
			<ul className="subitems">
				{item.removed_items.map((removedItem) => (
					<li
						key={`${removedItem.product?.name}${removedItem.quantity}${removedItem.total_price.amount}${removedItem.unit_price.amount}`}
						className="text-decoration-line-through"
					>
						<small>{getName(removedItem)}</small>
					</li>
				))}
				{item.included_items.map((includedItem) => (
					<li
						key={`${includedItem.product?.name}${includedItem.quantity}${includedItem.total_price.amount}${includedItem.unit_price.amount}`}
					>
						<small>{getName(includedItem)}</small>
						{renderThirdLevel(includedItem)}
					</li>
				))}
			</ul>
		);
	};

	const renderThirdLevel = (subItem: OrderItemData) => {
		const subItemItems: (OrderItemData & { removed?: boolean })[] = [
			...subItem.included_items,
			...subItem.removed_items.map((removedItem) => ({
				...removedItem,
				removed: true,
			})),
		];

		if (subItemItems.length === 0) return <></>;

		return (
			<small className="ms-1">
				(
				{subItemItems.map((subItem, index) => (
					<React.Fragment
						key={`${subItem.product?.name}${subItem.quantity}${subItem.total_price.amount}${subItem.unit_price.amount}`}
					>
						<small className={`${subItem.removed ? "text-decoration-line-through" : ""}`}>
							{getName(subItem)}
						</small>
						{index < subItemItems.length - 1 && ", "}
					</React.Fragment>
				))}
				)
			</small>
		);
	};

	return (
		<li className="item-info">
			{renderFirstLevel()}
			{renderSecondLevel()}
		</li>
	);
};

export default ItemListItem;
